// [per-office 2026-10-04] The office the OPEN AI tool works for.
// The AI tool (ai-details), its tab components and its dialogs each read the logged-in office from
// the session. When the tool is opened for another office (Referral Management > Recipients popup,
// a provider's line), ai-details sets that office here while it is open; the tab components and
// dialogs created under it pick it up through resolve(). Nothing set = the session office, so every
// other screen that hosts the AI tool is unaffected.
export class AiToolOffice {
  private static officeID = 0;

  static set(officeID: number): void {
    AiToolOffice.officeID = Number(officeID) > 0 ? Number(officeID) : 0;
  }

  static clear(): void {
    AiToolOffice.officeID = 0;
  }

  /** The office the open AI tool works for, else the given session office. */
  static resolve(sessionOfficeID: any): any {
    return AiToolOffice.officeID > 0 ? AiToolOffice.officeID : sessionOfficeID;
  }
}
